import { Trans } from 'react-i18next'

import { DocumentationBasePathProvider } from '@/components/documentation'
import { Simulateur } from '@/components/Simulateur/Simulateur'
import {
	ComparateurProvider,
	ModèleAssimiléSalarié,
	ModèleAutoEntrepreneur,
	ModèleTravailleurIndépendant,
	simulationEstCommencée,
	useComparateur,
} from '@/contextes/comparateur'
import { Body, Emoji, Intro, Link, Message, Strong } from '@/design-system'
import { usePageMetadata } from '@/hooks/usePageMetadata'
import { useSitePaths } from '@/sitePaths'

import SimulateurPageLayout from '../SimulateurPageLayout'
import { DétailSimulation } from './components/DetailSimulation'
import { ModaleDeDocumentation } from './components/ModaleDeDocumentation'
import { comparaisonStatutsMetadata } from './metadata'
import { Objectifs } from './Objectifs'
import { groupesDeQuestions, questionsPrincipales } from './questions'

export const ComparateurDeStatuts = () => (
	<ComparateurProvider
		modèles={[
			ModèleAssimiléSalarié,
			ModèleTravailleurIndépendant,
			ModèleAutoEntrepreneur,
		]}
	>
		<PageComparateur />
	</ComparateurProvider>
)

const PageComparateur = () => {
	const metadata = usePageMetadata(comparaisonStatutsMetadata)

	const { absoluteSitePaths } = useSitePaths()

	const { situation, set } = useComparateur()

	return (
		<SimulateurPageLayout metadata={metadata} showDate={false}>
			<Trans i18nKey="pages.simulateurs.comparaison-statuts.notif">
				<Message type="secondary" icon={<Emoji emoji="✨" />} border={false}>
					<Body>
						Découvrez quel statut est le{' '}
						<Strong>plus adapté pour votre activité</Strong> grâce au{' '}
						<Link to={absoluteSitePaths.assistants['choix-du-statut'].index}>
							nouvel assistant au choix du statut
						</Link>{' '}
						!
					</Body>
				</Message>
			</Trans>
			<Intro>
				<Trans i18nKey="pages.simulateurs.comparaison-statuts.description">
					Lorsque vous créez votre entreprise, le choix du statut juridique va{' '}
					<Strong>
						déterminer à quel régime social le dirigeant est affilié
					</Strong>
					. Il en existe <Strong>trois différents</Strong>, avec chacun ses
					avantages et inconvénients. Avec ce comparatif, trouvez celui qui vous
					correspond le mieux.
				</Trans>
			</Intro>

			<DocumentationBasePathProvider
				basePath={absoluteSitePaths.simulateurs.comparaison}
			>
				<Simulateur
					metadata={metadata}
					montantsÀSaisir={<Objectifs />}
					questionsFourniesPrincipales={questionsPrincipales}
					groupesDeQuestionsFournies={groupesDeQuestions}
					situation={situation}
					simulationEstCommencée={simulationEstCommencée(situation)}
					détail={<DétailSimulation />}
					onReset={set.reset}
				/>

				<ModaleDeDocumentation />
			</DocumentationBasePathProvider>
		</SimulateurPageLayout>
	)
}
